import { useLocalization } from "@shared-ui/localization-context";
import * as React from "react";
import { UitkText } from "uitk-react-text";

interface PriceLockupGetRatesProps {
  className: string;
}

export const PriceLockupGetRates = ({ className }: PriceLockupGetRatesProps) => {
  const { formatText } = useLocalization();

  return (
    <UitkText size={600} weight="bold" className={`hotelPricing ${className}`}>
      {formatText("hotels.price.getRates")}
    </UitkText>
  );
};

export default PriceLockupGetRates;
